<ul nz-menu>
  <ng-content></ng-content>
</ul>
